import React from 'react';
import { keyBy } from 'lodash';
import { getReactionOwner, getMemberCache } from '../../../common/store/members/members-selectors';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { LikeMetadata as LikeMetadataBase } from '../../../reactions';
import { ReactionCodeValue } from '../../../reactions/constants';
import { isDefined } from '../../../ts-utils';
import { useApi } from '../../api-provider';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useModal, LikeListModal } from '../modals';
const LikesMetadata = ({ reactionsState, commentId, config, className, t, isPending, }) => {
    const likeReactionState = keyBy(reactionsState.reactions, (r) => r.reactionCode)[ReactionCodeValue.LIKE] ?? { identities: [], reactionCode: ReactionCodeValue.LIKE, total: 0, hasReacted: false };
    const { resourceId, hideAvatars } = useConfiguration();
    const showModal = useModal();
    const { biOpenReactionList, memberCache, isMobile } = useApi((state, actions) => ({
        biOpenReactionList: actions.biOpenReactionList,
        memberCache: getMemberCache(state),
        isMobile: getIsMobile(state),
    }));
    const displayAmount = isMobile ? 2 : 3;
    const whoLiked = likeReactionState.identities
        .map((identity) => identity.identityId)
        .filter(isDefined)
        .slice(0, displayAmount);
    const ownersWhoLiked = whoLiked.map((id) => {
        const reactionOwner = getReactionOwner(memberCache, id);
        return reactionOwner.type === 'ANONYMOUS'
            ? reactionOwner
            : {
                identityId: reactionOwner.member.id,
                type: reactionOwner.type,
                name: reactionOwner.member.profile?.nickname ?? undefined,
                src: reactionOwner.member.profile.photo?.url ?? undefined,
            };
    });
    return likeReactionState.total !== 0 ? (React.createElement(LikeMetadataBase, { className: className, displayAmount: displayAmount, whoLiked: ownersWhoLiked, totalCount: likeReactionState.total, hideAvatars: hideAvatars, isMobile: isMobile, t: t, onClick: () => {
            biOpenReactionList({ resourceId, commentId, type: 'likes' });
            showModal((toggle) => (React.createElement(LikeListModal, { toggle: toggle, totalCount: likeReactionState.total, config: config, reactions: reactionsState })));
        }, isPending: isPending })) : null;
};
export default LikesMetadata;
//# sourceMappingURL=likes-metadata.js.map